export default __webpack_public_path__ + "static/sesame-d363c9568a6b66f77d8016aa34122ca7.svg";